import React, { ComponentProps, Suspense } from 'react';
import { LoadingSpinnerContainer } from '../../atoms/LoadingSpinner';

import { ImageCropperAspectRatioOptionsProps } from './ImageCropperAspectRatioOptions';
import { ImageCropperLandscapePortraitProps } from './ImageCropperLandscapePortrait';

const ImageCropperLandscapePortraitComponent = React.lazy(
  () => import(/* webpackChunkName: "imagecropper" */ './ImageCropperLandscapePortrait')
);
const ImageCropperAspectRatioOptionsComponent = React.lazy(
  () => import(/* webpackChunkName: "imagecropper" */ './ImageCropperAspectRatioOptions')
);

function isImageCropperComponentAspectRatioOptions(
  props: ImageCropperLandscapePortraitProps | ImageCropperAspectRatioOptionsProps
): props is ImageCropperAspectRatioOptionsProps {
  return !!(props as ImageCropperAspectRatioOptionsProps).userSelectableAspectRatios;
}

export function LazyImageCropper(
  props: ComponentProps<typeof ImageCropperLandscapePortraitComponent | typeof ImageCropperAspectRatioOptionsComponent>
) {
  return (
    <Suspense fallback={<LoadingSpinnerContainer />}>
      {isImageCropperComponentAspectRatioOptions(props) ? (
        <ImageCropperAspectRatioOptionsComponent {...props} />
      ) : (
        <ImageCropperLandscapePortraitComponent {...props} />
      )}
    </Suspense>
  );
}
